import { createContext } from 'react';

const ActivationOverviewContext = createContext<{
    handleSerialNumberRemove: (installationId: string, snId: string) => void;
    handleSerialNumberUndo: (installationId: string, snId: string) => void;
    handleEditConfirm: (installationId: string, newInstallationData: Record<string, string>) => void;
    setIsPEEnabled: (state: boolean) => void;
    isPEEnabled: boolean;
}>({
    handleSerialNumberRemove: () => {},
    handleSerialNumberUndo: () => {},
    handleEditConfirm: () => {},
    isPEEnabled: false,
    setIsPEEnabled: () => {},
});

export { ActivationOverviewContext };
